import { useMsal } from '@azure/msal-react';
import axiosInstance from '../axios/axiosConfig';

const useSendEmail = () => {
    const { instance, accounts } = useMsal();

    const sendEmail = async ({ subject, body, toRecipients, ccRecipients = [], from, attachment, importance = "Normal" }) => {
        if (accounts.length === 0) {
            console.error("No accounts found. Please log in.");
            return;
        }

        try {
            const silentRequest = {
                scopes: ["Mail.Send"],
                account: accounts[0],
            };

            let accessToken;

            try {
                const tokenResponse = await instance.acquireTokenSilent(silentRequest);
                accessToken = tokenResponse.accessToken;
            } catch (error) {
                console.error("Silent token acquisition failed, attempting interactive...", error);
                const interactiveTokenResponse = await instance.acquireTokenPopup(silentRequest);
                accessToken = interactiveTokenResponse.accessToken;
            }

            const email = {
                message: {
                    subject,
                    body: {
                        contentType: "HTML",
                        content: body,
                    },
                    toRecipients: toRecipients.map(email => ({
                        emailAddress: { address: email },
                    })),
                    // Add CC recipients if provided
                    ccRecipients: ccRecipients.map(email => ({
                        emailAddress: { address: email },
                    })),
                    from: {
                        emailAddress: { address: from },
                    },
                    importance, // Include importance field
                    attachments: attachment
                        ? [
                            {
                                "@odata.type": "#microsoft.graph.fileAttachment",
                                name: attachment.name,
                                contentBytes: attachment.contentBytes,
                                contentType: attachment.contentType,
                            },
                        ]
                        : [],
                },
            };

            await axiosInstance.post(
                "https://graph.microsoft.com/v1.0/me/sendMail", 
                email, 
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
            );
        } catch (error) {
            console.error("Error in sendEmail function:", error);
            if (error.response) {
                console.error("Error sending email. Status:", error.response.status);
                console.error("Error details:", error.response.data);
                throw new Error(`Failed to send email: ${error.response.data.error.message}`);
            }
            if (error.message.includes("Access is denied")) {
                console.error(
                    "Please check that all required permissions are granted in Azure AD and that your access token has the appropriate scopes."
                );
            }
            throw error; // Re-throw the error to propagate it back to the caller
        }
    };

    return sendEmail;
};

export default useSendEmail;
